// @flow

// !!! Please ensure `test/src/shared/config.test.js` is kept up to date if you modify this file. !!!
const endpoint =
  window._ENV_CONFIG_VARS && window._ENV_CONFIG_VARS.ORIGINATIONS_API_ENDPOINT;

export const API_PATH = '/api/v1';
export const LOCAL_API_ENDPOINT = `http://localhost:8080${API_PATH}`;

export const API_ENDPOINT =
  endpoint && endpoint !== 'undefined'
    ? `${window._ENV_CONFIG_VARS.ORIGINATIONS_API_ENDPOINT}${API_PATH}`
    : LOCAL_API_ENDPOINT;

export const FPOAPI_ENDPOINT =
  window._ENV_CONFIG_VARS &&
  window._ENV_CONFIG_VARS.FLEXIPAY_ORIGINATIONS_API_ENDPOINT;

export const DEPLOYMENT_ENVIRONMENT =
  window._ENV_CONFIG_VARS && window._ENV_CONFIG_VARS.DEPLOYMENT_ENVIRONMENT;

export const IS_LOCAL =
  !DEPLOYMENT_ENVIRONMENT || DEPLOYMENT_ENVIRONMENT === 'local';

export const LOQATE_API_KEY =
  window._ENV_CONFIG_VARS && window._ENV_CONFIG_VARS.LOQATE_API_KEY;

export const LARGE_LOAN_REDIRECTION_DISABLED =
  window._ENV_CONFIG_VARS &&
  window._ENV_CONFIG_VARS.LARGE_LOAN_REDIRECTION_DISABLED === 'true';

export const INCREASE_LOAN_AMOUNT_TO_750K =
  window._ENV_CONFIG_VARS &&
  window._ENV_CONFIG_VARS.INCREASE_LOAN_AMOUNT_TO_750K === 'true';

export const CLOUDWATCH_RUM_MONITOR_ENABLED =
  window._ENV_CONFIG_VARS &&
  window._ENV_CONFIG_VARS.CLOUDWATCH_RUM_MONITOR_ENABLED === 'true';

export const CLOUDWATCH_RUM_CONFIG_GUEST_ROLE_ARN =
  window._ENV_CONFIG_VARS &&
  window._ENV_CONFIG_VARS.CLOUDWATCH_RUM_CONFIG_GUEST_ROLE_ARN;

export const CLOUDWATCH_RUM_CONFIG_IDENTITY_POOL_ID =
  window._ENV_CONFIG_VARS &&
  window._ENV_CONFIG_VARS.CLOUDWATCH_RUM_CONFIG_IDENTITY_POOL_ID;

export const CLOUDWATCH_RUM_CONFIG_ENDPOINT =
  window._ENV_CONFIG_VARS &&
  window._ENV_CONFIG_VARS.CLOUDWATCH_RUM_CONFIG_ENDPOINT;

export const CLOUDWATCH_RUM_CONFIG_ALLOW_COOKIES =
  window._ENV_CONFIG_VARS &&
  window._ENV_CONFIG_VARS.CLOUDWATCH_RUM_CONFIG_ALLOW_COOKIES === 'true';

export const CLOUDWATCH_RUM_CONFIG_ENABLE_XRAY =
  window._ENV_CONFIG_VARS &&
  window._ENV_CONFIG_VARS.CLOUDWATCH_RUM_CONFIG_ENABLE_XRAY === 'true';

export const CLOUDWATCH_RUM_APPLICATION_ID =
  window._ENV_CONFIG_VARS &&
  window._ENV_CONFIG_VARS.CLOUDWATCH_RUM_APPLICATION_ID;

export const CLOUDWATCH_RUM_APPLICATION_VERSION =
  window._ENV_CONFIG_VARS &&
  window._ENV_CONFIG_VARS.CLOUDWATCH_RUM_APPLICATION_VERSION;

export const CLOUDWATCH_RUM_APPLICATION_REGION =
  window._ENV_CONFIG_VARS &&
  window._ENV_CONFIG_VARS.CLOUDWATCH_RUM_APPLICATION_REGION;

export const GOOGLE_ANALYTICS_ACCOUNT_ID =
  (window._ENV_CONFIG_VARS &&
    window._ENV_CONFIG_VARS.GOOGLE_ANALYTICS_ACCOUNT_ID) ||
  'UA-TEST-ID';

export const GOOGLE_ANALYTICS_ENABLED =
  window._ENV_CONFIG_VARS &&
  window._ENV_CONFIG_VARS.GOOGLE_ANALYTICS_ENABLED === 'true';

export const GOOGLE_ANALYTICS_DEBUG_MODE =
  window._ENV_CONFIG_VARS &&
  window._ENV_CONFIG_VARS.GOOGLE_ANALYTICS_DEBUG_MODE === 'true';

export const GOOGLE_TAG_MANAGER_ENABLED =
  window._ENV_CONFIG_VARS &&
  window._ENV_CONFIG_VARS.GOOGLE_TAG_MANAGER_ENABLED === 'true';

export const GOOGLE_TAG_MANAGER_ACCOUNT_ID =
  (window._ENV_CONFIG_VARS &&
    window._ENV_CONFIG_VARS.GOOGLE_TAG_MANAGER_ACCOUNT_ID) ||
  'GTM-TEST-ID';
